import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { DogUnderMaintenanceImg, TgBlackIcon } from "@/assets"
import { openTgLink } from "@/helpers/openTgLink"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import styles from "./UnderMaintenance.module.scss"

export const UnderMaintenance: FC = () => {
  const { t, i18n } = useTranslation()

  const isUnderMaintenance = useAppSelector(
    AppSelectors.selectIsUnderMaintenance()
  )

  if (!isUnderMaintenance) return null

  return (
    <div className={clsx(styles.UnderMaintenance)}>
      <Container
        className={clsx(styles.UnderMaintenance_content)}
        triangleBottomPosLeft={"32px"}
        triangleTopPosLeft={"calc(100% - 58px)"}
      >
        <div className={clsx(styles.UnderMaintenance_content_title)}>
          <h1>{t("underMaintenance.h1")}</h1>
        </div>
        <div className={clsx(styles.UnderMaintenance_content_description)}>
          <p>{t("underMaintenance.h2.0")}</p>
          <hr />
          <p>{t("underMaintenance.h2.1")}</p>
        </div>
        <div className={clsx(styles.UnderMaintenance_content_button)}>
          <Button
            icon={<TgBlackIcon />}
            onClick={() =>
              openTgLink(
                i18n.language === "ru"
                  ? "https://t.me/labrador_labr_ru"
                  : "https://t.me/labrador_labr"
              )
            }
          >
            {t("underMaintenance.readNews")}
          </Button>
          <Button.Reload />
        </div>
        <img
          className={clsx(styles.UnderMaintenance_decorImg)}
          src={DogUnderMaintenanceImg}
          alt="dog"
        />
      </Container>
    </div>
  )
}
